import angular from "angular";
import angularMask from "angular-ui-mask";
import capitalizeFirst from "../capitalize-first/capitalize-first.module";

angular
    .module('registerForm.component', [angularMask, capitalizeFirst])
    .component('registerForm', {
        controller: ['$http', 'notifier', controller],
        template: require('./register-form.component.html'),
        bindings: {
            code: '@',
        }
    });

function controller($http) {

    let $ctrl = this;

    $ctrl.$onInit = function () {

        $ctrl.bin = null;
        $ctrl.email = null;
        $ctrl.lastName = null;
        $ctrl.firstName = null;
        $ctrl.phone = null;
        $ctrl.position = null;
        $ctrl.password = null;
        $ctrl.confirmPassword = null;
        $ctrl.isAgree = false;
        $ctrl.passwordStrength = 0;
        $ctrl.passwordMessage = [];
        $ctrl.confirmMessage = [];
        $ctrl.matches = false;
        $ctrl.loading = false;

        // if ($ctrl.invite && $ctrl.invite.status == 'active') {
        //     setInvite();
        // }
    };

    function setInvite() {
        $ctrl.email = $ctrl.invite.email;
        $ctrl.lastName = $ctrl.invite.last_name;
        $ctrl.firstName = $ctrl.invite.first_name;
        $ctrl.phone = $ctrl.invite.phone;
        $ctrl.position = $ctrl.invite.position;
    }

    $ctrl.changePassword = function () {
        $ctrl.passwordStrength = ($ctrl.password) ? checkPasswordStrength() : 0;

        if(!$ctrl.password) {
            $ctrl.passwordMessage = []
            $ctrl.passwordMessage.push(' ')
        }

        if ($ctrl.passwordStrength < 3) {
            $ctrl.passwordMessage = []
            $ctrl.passwordMessage.push('Несложный пароль');
        }

        if ($ctrl.passwordStrength >= 3) {
            $ctrl.passwordMessage = []
            $ctrl.passwordMessage.push('Надежный пароль');
        }
    };

    function checkPasswordStrength() {

        let userInputs = [];

        if ($ctrl.firstName) {
            userInputs.push($ctrl.firstName);
        }

        if ($ctrl.lastName) {
            userInputs.push($ctrl.lastName);
        }

        if ($ctrl.email) {
            userInputs.push($ctrl.email);
        }

        let res = window.zxcvbn($ctrl.password, userInputs);

        return res.score;
    }

    $ctrl.submit = function () {

        if ($ctrl.loading) {
            return;
        }

        $ctrl.errorMessages = [];

        if (! $ctrl.isAgree) {
            $ctrl.errorMessages.push('Пожалуйста, примите условия соглашения');
        }

        if ($ctrl.password != $ctrl.confirmPassword) {
            $ctrl.matches = false;
            $ctrl.confirmMessage = []
            $ctrl.confirmMessage.push('Пароли не совпадают');
        } else {
            $ctrl.matches = true;
            $ctrl.confirmMessage = []
            $ctrl.confirmMessage.push('Пароли совпадают');
        }

        if ($ctrl.passwordStrength < 3) {
            $ctrl.errorMessages.push('Ненадежный пароль');
        }

        if ($ctrl.errorMessages.length) {
            return;
        }

        $ctrl.loading = true;

        $http
            .post('/register', {
                secret: $ctrl.code,
                email: $ctrl.email,
                first_name: $ctrl.firstName,
                last_name: $ctrl.lastName,
                phone: $ctrl.phone,
                position: $ctrl.position,
                password: $ctrl.password,
                password_confirmation: $ctrl.confirmPassword,
            })
            .then(
                function () {
                    $ctrl.loading = false;
                    $ctrl.isDone = true;
                    window.location = '/';
                },
                function (error) {
                    $ctrl.errorMessages = error.data.messages;
                    $ctrl.loading = false;
                }
            );
    };

}

export default "registerForm.component";


// WEBPACK FOOTER //
// ./resources/assets/modules/register-form/register-form.component.js